<script lang="ts">

    import EditDialogView from "../../../../../component/common/Dialog/EditDialogView.svelte";
    import {UrlUtil} from "../../../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../../../lib/Common/Http/HttpRequestUtil";
    import {createEventDispatcher} from "svelte";
    import PortalView from "../../../../../component/common/Portal/PortalView.svelte";
    import InputAreaView from "../../../../../component/common/Form/InputAreaView.svelte";
    import {SpaceCompanyDepartmentTable} from "../../../../../lib/Table/SpaceCompanyDepartmentTable";

    const dispatcher = createEventDispatcher();

    export let editData;


    function close() {
        dispatcher('close');

    }

    function save() {

        const url = UrlUtil.createApiUrl("space_company_department");

        HttpRequestUtil.postRequest(url, editData, (response) => {

            console.log(response);
            const body = response['body'];

            dispatcher('update');
            close();

        });
    }

</script>

<PortalView>

    <EditDialogView editData={editData} on:save={save} on:cancel={close} title="スペースの会社部署編集">
        <div class="space-company-department-edit-dialog-content">
            <div>
                <InputAreaView label="会社名">
                    <input class="input-company-name" list="company-list" type="text"
                           placeholder="株式会社バンダイナムコスタジオ ※全角半角注意"
                           bind:value={editData.company_name}/>
                </InputAreaView>
            </div>
            <div>
                <InputAreaView label="部署名">
                    <input class="input-department-name" type="text" placeholder="○○スタジオ○○プロダクション ※全角半角注意"
                           bind:value={editData.department_name}/>
                </InputAreaView>
            </div>

            <div>
                <InputAreaView label="権限種別">
                    <select class="authority-type" bind:value={editData.authority_type}>
                        {#each Object.entries(SpaceCompanyDepartmentTable.AuthorityType.map) as [id, name]}
                            <option value={Number(id)}>
                                {name}
                            </option>
                        {/each}

                    </select>
                </InputAreaView>
            </div>


            <div class="tips">
                <div class="title">
                    追加例
                </div>
                <div class="box">
                    【会社】
                    全角半角注意。ある程度はリストから選べます。

                    【部署】
                    「第３スタジオ第１グループ第３プロダクションアートセクション」
                    「第３スタジオ第１グループ第３プロダクションクライアントエンジニア」
                    こちら両方を含めたい場合は、「第３スタジオ第１グループ第３プロダクション」

                    「第３スタジオ第１グループ第３プロダクション」と入れると、
                    第３スタジオ第１グループ第３プロダクション　から始まる人が権限の対象になる。

                </div>
            </div>

        </div>

        <datalist id="company-list">
            <option>株式会社バンダイナムコスタジオ</option>
            <option>株式会社バンダイナムコエンターテインメント</option>
            <option>株式会社バンダイナムコ研究所</option>
            <option>株式会社バンダイナムコアミューズメントラボ</option>
            <option>株式会社バンダイナムコオンライン</option>
            <option>バンダイナムコスタジオシンガポール</option>
        </datalist>

    </EditDialogView>
</PortalView>

<style lang="scss">
    .space-company-department-edit-dialog-content {
        .input-company-name {
            min-width: 32em;
        }

        .input-department-name {
            min-width: 64em;
        }

        .tips {
            .title {
                opacity: 0.5;
                font-size: 0.7em;
                margin-top: 32px;
            }

            .box {
                white-space: pre-line;
                font-size: 0.8em;
                border-style: solid;
                border-width: 1px;
                background-color: #0001;
                border-color: #0002;
                padding: 12px;
                border-radius: 4px;
                margin-bottom: 24px;

            }
        }
    }


</style>